
import "./Partners.css";
import partner1 from "../Assets/partners/Sieger.svg";
import partner2 from "../Assets/partners/hin1.png";
import partner3 from "../Assets/partners/koshi.jpg";
import partner4 from "../Assets/partners/arc.png";
import vishnu from "../Assets/partners/vishnu.png";
import partner5 from "../Assets/partners/iiclogo-1.png";

const partners = [
  { id: 1, name: "Sieger",  logo:partner1 },
  { id: 2, name: "SHMS",  logo:partner2 },
  { id: 3, name: "Koshi Motors", logo:partner3 },
  { id: 4, name: "IIC",  logo: partner4 },
  { id: 5, name: "Vishnu motor sports",  logo: vishnu },
  { id: 6, name: "ARC Global",  logo: partner5 },
];

export default function Partners() {
  return (
    <section className="partners-section" id="partners">
      <div className="partners-header">
        <h2 className="section-title">Our Partners</h2>
        <p>
          We collaborate with industry-leading partners to deliver
          an exceptional championship experience.
        </p>
      </div>

      <div className="partners-grid">
        {partners.map(p => (
          <div className="partner-card" id={`partner-${p.id}`} key={p.id}>
            <img src={p.logo} alt={p.name} className="partner-logo" />
          </div>
        ))}
      </div>
    </section>
  );
}
